// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"028dc2bf","498":"14cc5767","513":"38f3242d","787":"fdfb22c6"}[chunkId] + ".chunk.js";
};